import { gsap } from 'gsap/gsap-core';
import { lenis } from "../animations/scroll";

const BREAKPOINT = 1366;
const BURGER_OPEN_CLASS = "has-burger--open";
const BURGER_MENU_OPEN_CLASS = "burger-menu--open";
const SUBMENU_OPEN_CLASS = "submenu--open";

export const init = (): void => {
    const nav = document.getElementById('main-menu');
    const burgerContainer = document.querySelector<HTMLElement>('.site-header .header-burger .menu');
    const desktopContainer = document.querySelector<HTMLElement>('.site-header .header-menu');

    if (!nav || !burgerContainer || !desktopContainer) return;

    const mediaQuery = window.matchMedia(`(max-width: ${BREAKPOINT}px)`);

    const handleMenuChange = (e: MediaQueryListEvent | MediaQueryList): void => {
        const target = e.matches ? burgerContainer : desktopContainer;
        target.appendChild(nav);
        nav.removeAttribute('hidden');
    };

    mediaQuery.addEventListener('change', handleMenuChange);
    handleMenuChange(mediaQuery);

    initBurgerMenu();
};

const initBurgerMenu = (): void => {
    const burgerMenuWrap = document.querySelector<HTMLElement>(".header-burger");
    if (!burgerMenuWrap) return;

    const menuButton = document.querySelector<HTMLButtonElement>(".burger-button");
    const closeButton = document.querySelector<HTMLButtonElement>(".burger-close-btn");
    const backdrop = burgerMenuWrap.querySelector<HTMLElement>(".burger-backdrop");
    const menuContent = burgerMenuWrap.querySelector<HTMLElement>(".burger-content");
    const dropdowns = burgerMenuWrap.querySelectorAll<HTMLElement>(".dropdown");

    if (!menuButton || !closeButton || !backdrop || !menuContent) return;

    gsap.set(menuContent, { opacity: 1, xPercent: -100 });

    const isMenuOpen = (): boolean => document.body.classList.contains(BURGER_OPEN_CLASS);

    const setMenuOpen = (open: boolean): void => {
        const method = open ? "add" : "remove";
        document.body.classList[method](BURGER_OPEN_CLASS);
        burgerMenuWrap.classList[method](BURGER_MENU_OPEN_CLASS);

        gsap.to(menuContent, {
            xPercent: open ? 0 : -100,
            duration: open ? 0.6 : 0.4,
            ease: open ? "power2.out" : "power2.in",
        });

        open ? lenis.stop() : lenis.start();
    };

    const toggleMenu = (): void => setMenuOpen(!isMenuOpen());

    const setDropdownOpen = (dropdown: HTMLElement, submenu: HTMLElement, open: boolean): void => {
        dropdown.classList.toggle("is-clicked", open);

        if (open) {
            submenu.style.display = "flex";
            submenu.style.height = "0";
            gsap.to(submenu, {
                height: submenu.scrollHeight,
                duration: 0.5,
                onComplete: () => {
                    submenu.style.height = "auto";
                    submenu.classList.add(SUBMENU_OPEN_CLASS);
                },
            });
        } else {
            gsap.to(submenu, {
                height: 0,
                duration: 0.5,
                onComplete: () => {
                    submenu.style.display = "none";
                    submenu.classList.remove(SUBMENU_OPEN_CLASS);
                },
            });
        }
    };

    dropdowns.forEach((dropdown) => {
        dropdown.addEventListener("click", () => {
            const submenu = dropdown.nextElementSibling as HTMLElement | null;
            if (!submenu) return;

            const isOpen = submenu.classList.contains(SUBMENU_OPEN_CLASS);
            setDropdownOpen(dropdown, submenu, !isOpen);
        });
    });

    menuButton.addEventListener("click", toggleMenu);
    closeButton.addEventListener("click", () => setMenuOpen(false));
    backdrop.addEventListener("click", () => setMenuOpen(false));
};
